import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { Modal, Form, Input, Select } from "antd";
import { identity } from "../../utils/getIdentity";
import '../SignPasswordModal/style.scss';
import '../../layout/Modal.scss';
import '../ResendEmail2FA/style.scss';
import './style.scss';
import Button from "../Button";
import TokenIcon from "../TokenIcon";
import styles from "../SaleTokenCheckout/SaleTokenForm/SaleTokenForm.module.scss";
import { useDispatch } from "react-redux";
import { patchNotificationError } from "../../redux/actions/transactions";

const AddAddressModal = ({
  visible,
  close,
  typeNetwork,
  currencies,
  createAddressBook,
  addressBookList,
  user = null,
  setUser,
  changeAddressBook,
  notificationsChangeError
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const initialValues = {
    name: "",
    network: undefined,
    walletAddress: ""
  };

  useEffect(() => {
    if (user) {
      const network = currencies?.filter(item => item?.nodeType === user?.wallets[0]?.nodeType && item?.currencyType === 'currency');
      form.setFieldsValue({
        name: user?.name,
        walletAddress: user?.wallets[0]?.address,
        network: network[0]?._id
      })
    }
  }, [user]);

  const changeForm = (name, value) => form.setFieldsValue({ [name]: value });

  const handleClose = () => {
    form.resetFields();
    setUser(null);
    close();
  };

  const handleSubmit = async (values) => {
    const network = currencies?.filter(item => item?._id === values?.network);

    if (user) {
      await changeAddressBook(user?._id, {
        name: values?.name,
        wallets: [{
          nodeType: network[0]?.nodeType,
          address: values?.walletAddress,
        }],
        typeNetwork: typeNetwork
      });
    } else {
      await createAddressBook({
        name: values?.name,
        wallets: [{
          nodeType: network[0]?.nodeType,
          address: values?.walletAddress,
        }],
        typeNetwork: typeNetwork
      });
    }
  };

  useEffect(() => {
    if (!notificationsChangeError) {
      dispatch(patchNotificationError(true));
      handleClose();
      addressBookList();
    }
  }, [notificationsChangeError]);

  return (
    <div className={`sign-password-modal sign-password-modal-${identity}`}>
      <Modal
        title={user ? t('addressBook.change_account') : t('addressBook.add_new_account')}
        visible={visible}
        width={385}
        onCancel={handleClose}
        footer={null}
        className={`modal modal-${identity}`}
      >
        <Form
          form={form}
          className="form"
          initialValues={initialValues}
          onFinish={values => handleSubmit(values)}
        >
          <div className="sign-password address-modal">
            <Form.Item
              label={t("addressBook.name")}
              name="name"
              className="form__item"
              rules={[{ required: true, message: t('addressBook.enter_name') }]}
            >
              <Input
                className="form__input"
                placeholder={t("addressBook.name")}
                onChange={e => changeForm('name', e?.target?.value)}
              />
            </Form.Item>
            <Form.Item
              label={t('addressBook.network')}
              name="network"
              className="form__item"
              rules={[{ required: true, message: t('addressBook.enter_network') }]}
            >
              <Select placeholder={t('addressBook.select_network')} onChange={value => changeForm('network', value)}>
                {currencies?.length && currencies?.map((item) => (
                  <>
                    {item?.currencyType === 'currency' && (
                      <Select.Option key={item._id} value={item._id} id={item?.nodeType}>
                        <TokenIcon
                          className={styles['sale-token-form__select-option-icon']}
                          tokenName={item.name}
                        />
                        {item.title}
                      </Select.Option>
                    )}
                  </>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label={t('addressBook.wallet_address')}
              name="walletAddress"
              className="form__item"
              rules={[{ required: true, message: t('addressBook.enter_wallet') }]}
            >
              <Input
                className="form__input"
                placeholder={t('addressBook.wallet_address')}
                onChange={e => changeForm('walletAddress', e?.target?.value)}
              />
            </Form.Item>
          </div>

          <div className="modal-buttons">
            <Button type="submit">{!user ? t('addressBook.add') : t('addressBook.save_changes')}</Button>
          </div>
        </Form>
      </Modal>
    </div>
  )
};

export default AddAddressModal;